export const defaultTaxRegisHistory = {
	TaxReturnRegisHistoryData: [],
	Total: 0,
	TotalHistoryRegister: 0, //Tổng số bản ghi lịch sử đăng ký tờ khai nộp thuế qua mạng
	ListHistoryRegister: [] //Danh sách lịch sử đăng ký tờ khai nộp qua mạng
};

export default {
	...defaultTaxRegisHistory
};
